import React, { useEffect, useMemo, useState } from "react";
import './CustomEnvModal.css';
import { Form, Input, Radio, Select, Button, message, Space } from "antd";
import { debounce } from "../util/deboune";
import {createEnv, getQuotaPermit} from '../ApiService'
import warningPng from '../component/icons/png/warning.png'

//不能自定义依赖的语言(只能从下拉options里选择)
const noCustomLangs = ["c","cpp"]

const CustomEnvModal = (props) => {
  const { setVisible, packageList, lang, getEnvList, setPageLoading, initPackages, onClick, langConfig, authInfo, setNewEnvId } = props;
  const [envCreatForm] = Form.useForm();
  const [versionNum, setVersionNum] = useState([]);
  const [packageListNow, setPackageListNow] = useState([]);

  const [creating, setCreating] = useState(false);

  let CREATE_TIMEOUT = null;
  let CREATE_INTERVAL = null;

  useEffect(() => {
    const pList = [...packageList];
    setPackageListNow(pList.slice(0, 10));
    envCreatForm.setFieldsValue({ envName: lang + formatTime() });
    initPackages && envCreatForm.setFieldsValue({ dependentPackage: initPackages });
    // envCreatForm.setFieldsValue({ dependentPackage: [pList[0].project] });
  }, [packageList, lang, initPackages]);

  useEffect(() => {
    envCreatForm.setFieldsValue({ versionCode: versionNum?.[0]?.value });
  }, [versionNum])

  useEffect(() => {
    const list = langConfig?.versionList;
    setVersionNum(list);
  }, [lang]);

  const init = () => {
    envCreatForm.resetFields();
    envCreatForm.setFieldsValue({ envName: lang + formatTime() });
    // envCreatForm.setFieldsValue({ dependentPackage: [packageList[0].project] });
    envCreatForm.setFieldsValue({ versionCode: versionNum?.[0]?.value });
  }

  const formatTime = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份补零
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const close = () => {
    init();
    setVisible(false);
  }

  const create = () => {
    envCreatForm.validateFields().then(async val => {
      //限额判断
      const {status, message:error} = await getQuotaPermit(authInfo.token, authInfo.labInfo.code)
      if (status > 200) {
        message.error(error)
        return
      }
      const { envName, dependentPackage, versionCode } = val;
      const params = {
        lang,
        name: envName,
        from: versionCode,
        packages: dependentPackage,
        token: authInfo.token
      }
      message.info("环境正在加速创建中，请耐心等待");
      setCreating(true);
      setPageLoading(true);
      CREATE_TIMEOUT = setTimeout(() => {
        message.error('环境创建失败，请稍后再试。');
        clearInterval(CREATE_INTERVAL);
        clearTimeout(CREATE_TIMEOUT);
        setCreating(false);
        setPageLoading(false);
        // init();
      }, 30000)
      CREATE_INTERVAL = setInterval(() => {
          createEnv(params).then((data) => {
            if (data.success === true) {
              message.success("创建成功");
              clearInterval(CREATE_INTERVAL);
              clearTimeout(CREATE_TIMEOUT);
              setCreating(false);
              setPageLoading(false);

              getEnvList(langConfig, ()=> {setNewEnvId(data.id)});
              setVisible(false);
              init();
            }
          })
        }, 2000)

    })
  }

  const fetchOptions = (val) => {
    const list = []
    for (let i = 0; i < packageList.length - 1; i++) {
      if (list.length === 10) break;
      if (packageList[i]?.project.indexOf(val) > -1) {
        list.push(packageList[i]);
      }
    }

    return list;
  }

  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      setPackageListNow([]);
      const res = fetchOptions(value);
      setPackageListNow(res);
    };
    return debounce(loadOptions, 300);
  });

  return (
    <div className="customEnvModal"
      onClick={onClick}
    >
      <div className="header">
        创建实验室环境
      </div>
      <div className="content">
        <div
          // message="非常抱歉，若无法满足需求，请点击 "
          className="questionTip"
          //type="warning"
          //closable={false}
        >
          <img src={warningPng} />
          <span>
            若无法满足需求，请点击
            <span
              onClick={() => {
              window.open('https://cloudlab.yuque.com/org-wiki-cloudlab-smmg5w/txzm5f/lwyygrcf2gc8v01w?singleDoc# ');
              }}
              className="blueText"
            >
              这里
            </span> 反馈问题～
          </span>
        </div>
        <Form layout="vertical" form={envCreatForm}>
          <Form.Item label="环境名称：" name="envName" rules={[{ required: true, message: '请输入' }]}>
            <Input showCount maxLength={50} placeholder="请输入环境名称" />
          </Form.Item>
          <Form.Item label="版本号：" name="versionCode" rules={[{ required: true, message: '请选择' }]}>
            <Radio.Group>
              {
                versionNum.map(({ label, value }) => {
                  return <Radio.Button key={value} value={value}>{label}</Radio.Button>
                })
              }
            </Radio.Group>
          </Form.Item>
          <Form.Item label="依赖包：" name="dependentPackage" rules={[{ required: true, message: '请选择' }]}>
            <Select
              className="dependentPackage"
              mode={noCustomLangs.includes(lang)?"multiple":"tags"}
              maxCount={20}
              showCount
              fieldNames={{ label: 'project', value: 'project' }}
              filterOption={false}
              onSearch={debounceFetcher}
              placeholder="输入关键词选择筛选条件"
              options={packageListNow}
              defaultValue={initPackages}
            />
          </Form.Item>
        </Form>
      </div>
      <Space className="footer">
        {/* <Button onClick={() => setVisible(false)}>取消</Button> */}
        <Button style={{ width: '88px', height: '32px', borderRadius: '8px', marginTop: '24px' }} loading={creating} type="primary" onClick={create}>创建</Button>
      </Space>
    </div>
  )
}

export default CustomEnvModal;
